import { PolymerElement, html } from "@polymer/polymer";
import "@polymer/polymer/lib/elements/dom-if.js";

import iconVideoBlack from "../../../../images/icons/icon_video_black.svg";
import iconModuleBlack from "../../../../images/icons/icon_module_black.svg";
import iconTimeBlack from "../../../../images/icons/icon_time_black.svg";
import iconArrowDown from "../../../../images/icons/ic_arrowdown_24.svg";
import iconArrowUp from "../../../../images/icons/ic_arrowup_24.svg";

import { checkUserPassedPostTest, checkUserFailedPostTest, checkIsUserEnrolled, _getModuleEcourseTestStatus, _isVideoContent, _isArticleContent } from "../../../../utils/ecourse";

import Alodokter from "../../../../utils/Alodokter";
import EcourseAnalytics from "../../../../analytics/EcourseAnalytics";

import "./EcourseModule.style";

class EcourseModule extends PolymerElement {
  static get template() {
    return html`
      <style include="ecourse-module-style"></style>
      <div class="content">
        <div class="flexbox">
          <template is="dom-if" if="{{checkIsUserEnrolled(userStatus)}}">
            <div class="title-module-not-registered" value="{{module.id}}">
              <img src="{{getIconSrc(module.type)}}" class="icon-content-black"/> {{module.title}}</div>
          </template>
          <template is="dom-if" if="{{!checkIsUserEnrolled(userStatus)}}">
            <div class="title-module" value="{{module}}" on-click="onClickButtonDetailModule">
              <img src="{{getIconSrc(module.type)}}" class="icon-content-black"/> {{module.title}}</div>
          </template>
          <template is="dom-if" if="{{module.description}}">
            <div class="btn-collapsible" on-click="onClickCollapsible">
              <img src="{{iconCollapsible}}" />
            </div>
          </template>
        </div>
        <div class="text-durasi"><img src="{{iconTimeBlack}}" /> Durasi Belajar: {{module.duration}}</div>
        <div class="text-description" inner-h-t-m-l="{{module.description}}"></div>
        <div class="container-module">
          <dom-if if="{{checkUserPassedPostTest(module, userStatus)}}">
            <template>
              <div class="text-is-passed"><p>Lulus</p></div>
            </template>
          </dom-if>
          <dom-if if="{{checkUserFailedPostTest(module, userStatus)}}">
            <template>
              <div class="text-is-failed"><p>Belum Lulus</p></div>
            </template>
          </dom-if>
          <template is="dom-if" if="{{!checkIsUserEnrolled(userStatus)}}">
            <template is="dom-if" if="{{checkUserFailedPostTest(module, userStatus)}}">
              <div class="view-module" value="{{module}}" on-click="onClickButtonDetailModule">Coba Tes Lagi</div>
            </template>
            <template is="dom-if" if="{{!checkUserFailedPostTest(module, userStatus)}}">
              <div class="view-module" value="{{module}}" on-click="onClickButtonDetailModule">Lihat Materi</div>
            </template>
          </template>
        </div>
      </div>
    `;
  }

  static get properties() {
    return {
      index: {
        type: Number,
      },
      module: {
        type: Object,
      },
      userStatus: {
        type: String,
      },
      moduleOrder: {
        type: Number,
      },
      ecourseId: {
        type: String,
      },
      ecourseAnalytic: {
        type: Object,
      },
      iconVideoBlack: {
        type: String,
        value: iconVideoBlack,
      },
      iconModuleBlack: {
        type: String,
        value: iconModuleBlack,
      },
      iconTimeBlack: {
        type: String,
        value: iconTimeBlack,
      },
      iconArrowDown: {
        type: String,
        value: iconArrowDown,
      },
      iconArrowUp: {
        type: String,
        value: iconArrowUp,
      },
      iconCollapsible: {
        type: String,
        value: iconArrowDown,
      },
      checkIsUserEnrolled: {
        type: Function,
        value: () => checkIsUserEnrolled
      },
      checkUserPassedPostTest: {
        type: Function,
        value: () => checkUserPassedPostTest
      },
      checkUserFailedPostTest: {
        type: Function,
        value: () => checkUserFailedPostTest
      },
      _getModuleEcourseTestStatus: {
        type: Function,
        value: () => _getModuleEcourseTestStatus
      },
    };
  }

  ready() {
    super.ready();
  }

  onClickButtonDetailModule(e) {
    const moduleOrder = this.moduleOrder;
    e.stopPropagation();
    this.onNavigationDetail(e.target.value);
    var progressStatus = "";
    if(this.checkUserPassedPostTest(this.module, this.userStatus) == true) {
      progressStatus = "passed";
    } else if(this.checkUserFailedPostTest(this.module, this.userStatus) == true) {
      progressStatus = "failed";
    } else {
      progressStatus = "not_started";
    }
    if(e.srcElement.className == 'title-module') {
      EcourseAnalytics.selectModule(this.module, this.ecourseId, 'module-title', moduleOrder, progressStatus);
    } else {
      EcourseAnalytics.selectModule(this.module, this.ecourseId, 'module-button', moduleOrder, progressStatus);
    }
  }

  onNavigationDetail(module) {
    this.sendGAEcourseModuleClick(module);
    window.location = window.location.origin + `/skp/` + module.id;
  }

  getIconSrc(type) {
    if (_isVideoContent(type)) {
      return this.iconVideoBlack;
    } else if (_isArticleContent(type)) {
      return this.iconModuleBlack;
    }
    return '';
  }

  sendGAEcourseModuleClick(module){
    const moduleOrder = this.moduleOrder;
    const moduleStatus = this._getModuleEcourseTestStatus(module)
    const eventLabel = `${this.ecourseAnalytic.userUid}ecourse_title: ${this.ecourseAnalytic.title} | ecourse_category: ${this.ecourseAnalytic.category} | ecourse_type: ${this.ecourseAnalytic.ecourseType} | module_id: ${module.id} | module_title: ${module.title} | skp_type: ecourse_module | status: ${moduleStatus} | module_order: ${moduleOrder} | device_category: desktop`
    Alodokter.sendEventGA("ecourse detail page", "ecourse_module_click", eventLabel);
  }

  onClickCollapsible(e) {
    e.stopPropagation();

    const ecourseDescription = this.shadowRoot.querySelector(".text-description");
    if (ecourseDescription.style.maxHeight) {
      this.iconCollapsible = this.iconArrowDown;
      ecourseDescription.style.maxHeight = null;
    } else {
      this.iconCollapsible = this.iconArrowUp;
      ecourseDescription.style.maxHeight = ecourseDescription.scrollHeight + "px";
    }
  }
}

customElements.define("ecourse-module", EcourseModule);